import type { MRT_DisplayColumnDef } from 'material-react-table';
import { useMemo } from 'react';

type UseTableRowCountProps = {
  isLoadingNext: boolean;
  tableDataLength: number;
  count?: number;
};

export const useTableRowCountText = (props: UseTableRowCountProps) => {
  const tableRowCountText = useMemo(() => {
    if (props?.isLoadingNext) {
      return 'Loading...';
    }

    const count = props?.count ?? null;

    if (count === null) {
      return 'Loading...';
    }

    if (count === -1) {
      return `Showing ${props.tableDataLength} of many`;
    }

    if (count === -2) {
      return `Showing ${props.tableDataLength} of ${props.tableDataLength}`;
    }

    return `Showing ${props.tableDataLength} of ${count}`;
  }, [props.tableDataLength, props?.count, props?.isLoadingNext]);

  return tableRowCountText;
};

export const columnDefaults = <T extends Record<string, unknown>>() => ({
  reset: {
    enableColumnFilter: false,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableSorting: false,
  } as Partial<MRT_DisplayColumnDef<T, never>>,
  noEdit: {
    enableEditing: false,
    muiEditTextFieldProps: {
      sx: { display: 'none' },
    },
  } as Partial<MRT_DisplayColumnDef<T, never>>,
});
